import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";

export const fetchPreferences = ({commit, dispatch}) => {

    commit('toggleLoadingState', true)
            
    axios.get('/preferences/index.php', accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('setPreferenceInformation', res.data.response)                  
        }
        
        dispatch('fetchTaxSetting')
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitPreferences = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/preferences/save.php', payload.preferences, accessTokenInfo.accessTokenInfo())
    .then(res => {

        if(res.data.status) {
            dispatch('submitTaxSetting', payload.taxSetting)
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/preferences/actions.js